import Vue from 'vue'
import Vuex from 'vuex'

import { authenticationModule } from './modules/authentication'
import { myclaimsModule } from './modules/myclaims'
import { repairoptionsModule } from './modules/repairoptions'
import { claimformModule } from './modules/claimform'
import resellerModule  from './modules/resellerCustomizations'
import { tigaGadgetModule } from './modules/tigaGadget'
import appLocalStorage from '../util/appLocalStorage'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    authentication: authenticationModule,
    myclaims: myclaimsModule,
    repairoptions: repairoptionsModule,
    claimform: claimformModule,
    reseller: resellerModule,
    gadget: tigaGadgetModule
  },
  mutations: {
    initialise (state) {
      // Expire store in localstorage if required
      appLocalStorage.checkTimeStampAndVersion().then(
        (result) => {
          //console.log(result)
          let json = appLocalStorage.getStore()
          if (json) {
            Object.assign(state, JSON.parse(json))
          }
        }
      )
    }
  },
  actions: {
    resetStore ({ commit }) {
      commit('myclaims/reset')
    },
    resetBeforeMakeAClaim ({ commit }) {
      commit('claimform/reset')
      commit('repairoptions/reset')
      commit('myclaims/reset')
    }
  }
})
